/**
 * extracts the path (domain + path without file) from a url
 * @param {String} scriptSrc url for script
 * @returns {String} the domain + path w/o file
 */
function getPublicPath(scriptSrc) {
    return scriptSrc.split("/").slice(0, -2).join("/") + "/"
}
/**
 * sets the webpack public path used for dynamic chunk loading
 * @param  {String} localDevPath optional param for setting local development public path
 */
function setPublicPath(localDevPath) {
    const scriptElements = document.getElementsByTagName("script")
    const scripts = Array.prototype.slice.call(scriptElements, 0)
    const analyticsScript = scripts.find(
        (script) => script.src.indexOf("analytics-dotcom/analyticsInit") > -1
    )
    if (!analyticsScript) {
        // ifDev("analyticsInit file not found on the page")
    } else if (localDevPath) {
        __webpack_public_path__ = localDevPath
    } else {
        __webpack_public_path__ = getPublicPath(analyticsScript.src)
    }
}
let plPublicPath
if (process.env.NODE_ENV === "dev") {
    plPublicPath = "//localhost:8083/"
}
setPublicPath(plPublicPath)
import("./init").catch((error) => {
    console.error("GOTEAM analytics initialization failed", error)
})
